import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Web Socket',
  attributeName: 'webSocket',
  fields: [
    {
      attributeName: 'enableWebSocket',
      helpText: 'If the app should try to connect to the web socket (default = false).',
      type: FormInputTypes.CHECKBOX,
      label: 'Enable web socket',
      default: false,
    },
    {
      attributeName: 'webSocketUrl',
      helpText: 'The URL of the websocket.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Web socket URL',
      placeholder: 'Input the web socket URL...',
    }
  ],
};
